/*
 * @Author: CaoYang
 * @Date: 2026-06-26 11:31:22
 * @LastEditTime: 2026-06-26 11:39:57
 * @FilePath: /qlgc-web/src/main.js
 * @Description: 
 * 
 * Copyright (c) 2026 by ${git_name_email}, All Rights Reserved. 
 */
import Vue from 'vue'
import App from './App.vue'
//引入路由
import router from './router'
import '@/assets/css/base.less'
// 引入自定义指令
import StickyBottom from '@/directives/stickyBottom'
Vue.directive('sticky-bottom', StickyBottom)
import 'vue-social-share/dist/client.css';
import 'element-ui/lib/theme-chalk/index.css';
import VueInfiniteScroll from 'vue-infinite-scroll';
//element ui按需引入
import { MessageBox } from 'element-ui'
import { Button, Scrollbar, Tabs, TabPane, Input, DatePicker, Pagination, Upload, Dialog, Form, FormItem, Select, Option, Dropdown, DropdownMenu, DropdownItem, Breadcrumb, BreadcrumbItem, Message, Radio, Table, TableColumn, Cascader,Progress,Steps, Step, Image  } from 'element-ui'
Vue.use(Button)
Vue.use(Scrollbar)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Input)
Vue.use(DatePicker)
Vue.use(Pagination)
Vue.use(Upload)
Vue.use(Dialog)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Select)
Vue.use(Option)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Radio)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Cascader)
Vue.use(Progress)
Vue.use(Steps)
Vue.use(Step)
Vue.use(Image)
Vue.use(VueInfiniteScroll);



Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox.confirm
Vue.config.productionTip = false
import moment from 'moment'
Vue.prototype.bus = new Vue()

Vue.filter('datefmt', function(input, fmtstring) { //当input为时间戳，需转为Number类型
	if (input) {
		if (input.toString().length==10){
			return moment(Number(input)*1000).format(fmtstring);
		}else{
			return moment(Number(input)).format(fmtstring);
		}
	} else {
		return "";
	}
});
new Vue({
  render: h => h(App),
  //注册路由
  router
}).$mount('#app')
